import { Component, inject } from '@angular/core';
import { WizardRouteViewUpgradeDirective } from './wizard-route-view-upgrade.directive';
import { ResponsiveLayoutService } from '@go-modules/services/responsive-layout/responsive-layout.service';

@Component({
	selector: 'wizard-route-view-wrapper',
	templateUrl: './wizard-route-view-wrapper.component.html',
	styleUrls: ['./wizard-route-view-wrapper.component.scss'],
	standalone: true,
	imports: [
		WizardRouteViewUpgradeDirective
	],
	host: {
		'[class]': 'responsiveLayout.cssClassString()'
	}
})
export class WizardRouteViewWrapperComponent {
	protected responsiveLayout = inject(ResponsiveLayoutService);
}
